<div class="surface-0 shadow-2 border-round my-2">
  <div class="px-3 py-2 flex align-items-center justify-content-between">
    <div
      class="md:w-4"
      [innerHTML]="
        'SETTLEMENTS.TOTAL_SETTLEMENT' | translate: { count: totalItems$.value }
      "
    ></div>
    <div
      class="md:w-4 md:flex align-items-center justify-content-center text-right md:text-center ml-2"
    >
      <div>
        <p-button
          icon="fa fa-filter"
          label="Filter By"
          (click)="filter_by.toggle($event)"
          styleClass="p-button-outlined text-sm"
        />
        <p-popover #filter_by styleClass="md:w-29rem surface-100">
          <ng-template #content>
            <form [formGroup]="customFilterForm">
              <!-- Dropdown Content -->
              <div class="-mx-4 -mt-4 p-3 border-bottom-1 border-300">
                <label class="font-medium text-700 text-xs mb-2 block uppercase"
                  >Date</label
                >
                <div class="flex align-items-center">
                  <p-datepicker
                    [showIcon]="false"
                    placeholder="Select Date"
                    formControlName="from"
                    styleClass="w-full"
                    inputStyleClass="text-sm"
                  />
                  <div class="text-sm mx-2">To</div>
                  <p-datepicker
                    [showIcon]="false"
                    placeholder="Select Date"
                    formControlName="until"
                    styleClass="w-full"
                    inputStyleClass="text-sm"
                  />
                </div>
              </div>
              <!-- Dropdown Content -->

              <!-- Dropdown Content -->
              <div
                class="-mx-4 -mb-4 p-3 flex align-items-center justify-content-between"
              >
                <p-button
                  (click)="filter_by.toggle($event)"
                  label="Cancel"
                  styleClass="p-button-danger p-button-text text-sm"
                />
                <p-button
                  (click)="
                    filter_by.toggle($event); applyFilter(customFilterForm)
                  "
                  label="Apply Filter"
                  styleClass="text-sm"
                />
              </div>
              <!-- Dropdown Content -->
            </form>
          </ng-template>
        </p-popover>
      </div>
      <div
        class="white-space-nowrap p-ripple p-element p-button p-component text-xs mt-2 md:mt-0 md:ml-2"
      >
        <strong class="font-bold">Date &nbsp;-&nbsp;</strong>
        <span
          >{{ getFromDate() | datetimeformat: 'defaultformat' }} to
          {{ getUntilDate() | datetimeformat: 'defaultformat' }}</span
        >
      </div>
    </div>

    <div class="hidden md:inline-block md:w-4"></div>
  </div>

  <app-data-grid
    [loading]="loading"
    [columnData]="tableData$"
    [columns]="columns$"
    [EmptyState]="emptyStateComponent$"
    [totalRecords]="totalRecordLength"
    (loadNextData)="fetchNextSetData($event)"
    [selectable]="false"
    (onAction)="onActionClick($event)"
    [gridName]="'ezypay-settlement-list'"
  />
</div>
